export { default } from './IconGroup';
